<template>
  <div class="hello page-roster">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput">
            <div>姓名</div>
            <el-input size="small" v-model="infoQuery.username" @keyup.enter.native="getImprtInfo()"></el-input>
          </div>
          <div class="screenInput">
            <div>身份证号</div>
            <el-input size="small" v-model="infoQuery.idcard" @keyup.enter.native="getImprtInfo()"></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>

      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>业务立项部门</div>
            <el-select v-model="infoQuery.strobjinstname" placeholder="请输入或选择" filterable>
              <el-option 
              v-for="(item,index) in apartmentList"
              :key="index"
              :label="item.StrObjInstName"
              :value="item.StrObjInstName"></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>负责客服</div>
            <el-input size="small" v-model="infoQuery.strusername"></el-input>
          </div>
          <div class="formScreenInput">
            <div>合同（协议）类型</div>
            <el-select v-model="infoQuery.strcontracttype" slot="prepend" placeholder="请选择" filterable>
              <el-option v-for="(item,index) in ContractType" :value="item" :key="index"></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>户粮</div>
            <el-select v-model="infoQuery.strcityzentype" slot="prepend" placeholder="请选择" filterable>
              <el-option v-for="(item,index) in CityzenType" :value="item" :key="index"></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>籍贯</div>
            <el-input size="small" v-model="infoQuery.strnativeplace"></el-input>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="clear()">清空</button>
          <button class="search" @click="getImprtInfo()">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/employee-historicalRoster' }">历史花名册</el-breadcrumb-item>
          <el-breadcrumb-item>{{this.custname}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="customerRosterTable">
        <el-table :data="tableData"  :max-height="tableHeight-180" v-loading="listLoading" border style="width: 99%" :lazy="true">
          <!-- <el-table-column align="center" type="selection" width="40"></el-table-column> -->
          <el-table-column align="center" fixed label="序号" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed prop="StrFileNo" label="档案号" width="100">
          </el-table-column>
          <el-table-column align="center" fixed prop="StrEmpName" label="姓名" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrEmpName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrSrvCent" label="服务中心" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.StrSrvCent }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBlCmp" label="劳动合同签署公司全称" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrBlCmp }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrObjName" label="项目名称" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.StrObjName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="subProject" label="子项目" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.subProject }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrProjectType" label="项目类别" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrProjectType }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrObjInstName" label="业务立项部门" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.StrObjInstName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrUserName" label="负责客服" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrUserName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrTmpProject" label="自定义项目" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.StrTmpProject }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrDepName" label="部门" width="130">
            <template slot-scope="scope">
              <div>{{ scope.row.StrDepName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrJobInf" label="岗位" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.StrJobInf }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrIdCard" label="身份证" width="180">
            <template slot-scope="scope">
              <div>{{ scope.row.StrIdCard }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="idcardJudge" label="判定" width="60">
            <template slot-scope="scope">
              <div :style="scope.row.idcardJudge ? '' : style1">{{scope.row.idcardJudge}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="sex" label="性别" width="60"></el-table-column>
          <el-table-column align="center" prop="birth" label="出生年月" width="120"></el-table-column>
          <el-table-column align="center" prop="age" label="年龄" width="60"></el-table-column>
          <el-table-column align="center" prop="StrPolitical" label="政治面貌" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrPolitical }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtIcCareEdate" label="身份证有效终止时间" width="150">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtIcCareEdate)?'':scope.row.DtIcCareEdate.substring(0,10)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrCityzenType" label="户粮" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.StrCityzenType }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrPhoneNum" label="联系方式" width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.StrPhoneNum }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrContName" label="紧急联系人" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrContName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrContTel" label="紧急联络方式" width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.StrContTel }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrNationClass" label="民族" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrNationClass }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrNativePlace" label="籍贯" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrNativePlace }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrNativeAddr" label="户籍地址" width="400">
            <template slot-scope="scope">
              <div>{{ scope.row.StrNativeAddr }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrAddr" label="现住地址" width="350">
            <template slot-scope="scope">
              <div>{{ scope.row.StrAddr }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrEduLv" label="教育程度" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrEduLv }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrInsuranceType" label="参保种类" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.StrInsuranceType }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtInsuranceDate" label="参保日期" width="100">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtInsuranceDate)?'':scope.row.DtInsuranceDate }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrMedicalCard" label="医保卡号" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrMedicalCard }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtEntryBdate" label="用工之日" width="100">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtEntryBdate)?'':scope.row.DtEntryBdate.substring(0,10)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合同（协议）类型" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.StrContractType }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="签定合同次数" width="100">
            <template slot-scope="scope">
              <div >{{ scope.row.IntContractNum }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="签订合同起止时间记录" width="400">
            <template slot-scope="scope">
              <div>{{ scope.row.StrContractBedate }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="试用期到期日期" width="150">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtProbationEdate)?'':scope.row.DtProbationEdate.substring(0,10) }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="劳动合同起始时间" width="150">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtContractBtime)?'':scope.row.DtContractBtime.substring(0,10)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="劳动合同到期时间" width="150">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtContractTime)?'':scope.row.DtContractTime.substring(0,10) }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrWorkState" label="在/离职状态" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrWorkState }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtDepartureDate" label="离职日期" width="100">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtDepartureDate)?'':scope.row.DtDepartureDate.substring(0,10)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtRealDepartureDate" label="实际离职日期" width="100">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtRealDepartureDate)?'': scope.row.DtRealDepartureDate.substring(0,10)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBankCard" label="银行卡号" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.StrBankCard }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBankName" label="银行" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.StrBankName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrWithdrawal" label="是否计提" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrWithdrawal }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrInCity" label="市内" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.StrInCity }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrOutsideCity" label="市外" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.StrOutsideCity }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrOther" label="其他情况" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.StrOther }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrPetype" label="体检类型" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrPetype }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrPeres" label="体检结果" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrPeres }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrEmpUsrStatus" label="人员状态" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.StrEmpUsrStatus }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtInjuryBdate" label="工伤纠纷发生时间" width="150">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtInjuryBdate)?'': scope.row.DtInjuryBdate.substring(0,10)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrDisabilityLevel" label="伤残等级" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrDisabilityLevel }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtInjuryEdate" label="工伤纠纷结束时间" width="150">
            <template slot-scope="scope">
              <div>{{ isNull(scope.row.DtInjuryEdate)?'': scope.row.DtInjuryEdate.substring(0,10)}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBlacklist" label="是否黑名单" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.StrBlacklist }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrBlacklistReason" label="黑名单原因" width="300">
            <template slot-scope="scope">
              <div>{{ scope.row.StrBlacklistReason }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrRemark" label="备注" width="300">
            <template slot-scope="scope">
              <div>{{ scope.row.StrRemark }}</div>
            </template>
          </el-table-column>
          <template v-for="(item,index) in tableTitle" >
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" :key="index"  width="200" align="center">
              <template slot-scope="scope">
                  <!-- <div  class="tableEditInput" v-if="scope.row.isEdit && scope.row.EditName==scope.column.property">
                    <el-input v-model="qdata[item.StrColumId]" :id="scope.row.IntExcelLine+scope.column.id"  @blur="editEmployee(scope.row,scope.column)"></el-input>
                  </div> -->
                   <!-- v-if="!scope.row.isEdit || scope.row.EditName!=scope.column.property" -->
                  <div>{{ scope.row[item.StrColumId] }}</div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block" v-if="Number(totalcount)>0">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage3"
            :page-size="pagecount"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,prev,sizes,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import FUN from "../../fun";
import xz from "../../common";
export default {
  name: "HelloWorld",
  data() {
    return {
       tableHeight:0,
      style1:{
        color:'rgb(255, 67, 98)'
      },
      apartmentList:[],
      pagecount:10,
      //历史导入字段
      historyChecked:'',
      //导入表
      tabName:'',
      tableList:[],
      //单选框
      radioVal:'',
      historyFiledList:[],
      listLoading:false,
      historyFiled:"",
      strsrvcentSel:'',
      //下拉项目名称
      objList:[],
      //下级人员列表(负责客服)
      subordinateList: [],
      //合同协议类型
      strcontracttype:"",
      // 户粮
      strcityzentype:"",
      //业务立项部门
      strobjinstname:"",
      //负责客服
      strusername:"",
      //籍贯
      strnativeplace:"",
      blackstatus:"",
      tableclumn:[],
      oldCluvalue:"",
      remarkText:"",
      blacklistReason:"",
      //表头内容
      tableTitle:[],
      lsdata: "",
      path: "",
      qdata: [],
      empinfo: "",
      custname: "",
      bank: this.$store.state.EMP.bank,
      CityzenType: this.$store.state.EMP.CityzenType,
      //分公司
      SrvCent: this.$store.state.EMP.SrvCent,
      //合同类型
      ContractType: this.$store.state.EMP.ContractType,
      // InsuranceType: this.$store.state.EMP.InsuranceType,
      //学历水平
      eduLv:this.$store.state.EMP.eduLv,
      //民族
      nationals:this.$store.state.EMP.nationals,
      checkAll: false,
      //字段选择默认选择
      checkedFields:[],
      // fields: this.$store.state.EMP.filed,
      fields:[],
      isIndeterminate: true,
      //手机号码格式是否正确
      phoneJudge: "",
      contTelJudge: "",
      qqq: 0,
      totalcount: 0,
      pageSize: 10,
      currpage: 1,
      drawer: false,
      //下拉筛选
      showDropScreen: -1,
      currentPage3: 1,
      textarea: "",
      tableData: [],
      dynamicTags: ["标签一", "标签二", "标签三"],
      emprow:"",
      //所有导入字段
      currFileData:[],
      infoQuery:{
            gdbakId:"",
            tableid:"XZ_emp_UserBase",
            pagecount:10,
            currpage:1,
            username:"",
            idcard:"",
            strcontracttype:"", //合同（协议）类型
            strnativeplace:"", //籍贯
            strcityzentype:"", //户粮
            strusername:"", //负责客服
            strobjinstname:"" //业务立项部门
      }
    };
  },
  computed: {
    // path(){
    //   return this.$store.state.EXCELPATH.excelPath
    // }
  },
  created() {
    this.calHeight();
    if(window.localStorage.getItem('page')){
      // this.infoQuery.pagecount = window.localStorage.getItem('page');
      this.pagecount = parseInt(window.localStorage.getItem('page'));
    }
    //下拉项目名称
    this.getObjList(this.strsrvcentSel)
    //下拉客服
    this.getMemberList()
    //固定字段
    this.getImportFiledList()
    this.getExcelPath();
    let q = this.$route.query;
    // console.log('q',q)
      (this.custname = q.custname),
      (this.infoQuery.gdbakId = q.gdbakId);
      this.getApartmentList(q.strServCentName,q.custname);
      this.getTabInfo()
      this.getImprtInfo()
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight);
      console.log('height',this.tableHeight) 
    },
    // 下拉选择表格
    selectTab(d) {
      this.tabId = d.value;
      this.tabName = d.label;
      console.log("d", d);
    },
     getTabInfo() {
      const gdata = {
        pagecount: 10,
        currpage: 1,
        tablename: "",
        ctluserid: ""
      };
      xz.getTableData(gdata, Cookies.get("userid-b")).then(res => {
        console.log("tab", res);
        this.tableList = res.data;
        this.tabName = res.data[0].StrTableName
        // console.log('tablelist',this.tableList)
      });
    },
    //下拉项目名称
    getObjList(strsrvcent){
      xz.getsrarchinstobjlist(strsrvcent).then(res => {
        // console.log("getApartmentList", res);
        let dataList = []
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          if(apartmentData.StrObjName!=''&&apartmentData.StrObjName!=' '){
            dataList.push({StrObjName:apartmentData.StrObjName})
          }
        }
        // console.log("getServeList", dataList);
        this.objList = dataList;
      });
    },
    //下级人员列表
    getMemberList(){
      xz.getallEmplowertListInfo().then(res => {
        // console.log('下级人员列表',res)
        if (res.data && Array.isArray(res.data)) {
          this.subordinateList = res.data;
        } else {
          this.subordinateList = [];
        }
      });
    },
    handleCurrentChange(val) {
      this.currpage = `${val}`;
      this.infoQuery.currpage = val
      this.getImprtInfo();
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.infoQuery.pagecount = parseInt(val);
        this.getImprtInfo();
    },
    clear() {
      this.infoQuery = {
            gdbakId:this.$route.query.gdbakId,
            tableid:"XZ_emp_UserBase",
            pagecount:this.pagecount,
            currpage:1,
            username:"",
            idcard:"",
            strcontracttype:"", //合同（协议）类型
            strnativeplace:"", //籍贯
            strcityzentype:"", //户粮
            strusername:"", //负责客服
            strobjinstname:"" //业务立项部门
      }
    },
    //获取表头信息
     getImportFiledList(){
      const data = {
        pagecount: 100000,
        currpage: 1,
        tablename: "",
        coluname: "",
        strisfixed:'0'  //strisfixed=1 固定字段 strisfixed=0 自定义拓展字段  all所有
      };
      this.fields = []
      xz.getImportFiledInfo(data).then(res =>{
        console.log('固定导出字段',res)
        if(res&&res.data.length>0){
          this.tableTitle = res.data;
        }else{
              this.tableTitle = []
        }
      })
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    //设置花名册显示字段
    setFieldShow() {
      this.dialogVisible9 = true;
    },
    removeField(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    //获取表格路径
    getExcelPath() {
      const data = {
        pagecount: 1000,
        currpage: 1,
        excelname: "",
        tableid: "",
        instname: "",
        impdate: ""
      };
      xz.getPathInfo(data).then(res => {
        // console.log('pathInfo',res)
        this.path = res.data[0].StrExcelPath;
        // console.log('pathInfo',this.path)
        this.getImprtInfo();
      });
    },
    //获取花名册信息
    getImprtInfo() {
      this.listLoading = true
      xz.getBackUpUsers(this.infoQuery).then(res => {
        console.log('xx',res)
        if(res.msg.data&&res.msg.data.length>0){
           this.tableData = res.msg.data;
           this.totalcount = parseInt(res.msg.totalcount);
           this.getPsInfo();
        }else{
          this.tableData = [];
          this.totalcount = 0
        }
        this.listLoading = false
       this.showDropScreen = -1;
      });
    },
    //获取出生年月、性别、年龄
    getPsInfo() {
      this.tableData.forEach(l => {
        let idcode = l.StrIdCard;
        // 加权因子
        var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
        // 校验码
        var check_code = ["1","0","X","9","8","7","6","5","4","3","2"];
        var code = idcode + "";
        var last = idcode[17]; //最后一个
        var seventeen = code.substring(0, 17);
        // ISO 7064:1983.MOD 11-2
        // 判断最后一位校验码是否正确
        var arr = seventeen.split("");
        var len = arr.length;
        var num = 0;
        for (var i = 0; i < len; i++) {
          num = num + arr[i] * weight_factor[i];
        }
        // 获取余数
        var resisue = num % 11;
        var last_no = check_code[resisue];

        // 格式的正则
        // 正则思路
        /*
	    第一位不可能是0
	    第二位到第六位可以是0-9
	    第七位到第十位是年份，所以七八位为19或者20
	    十一位和十二位是月份，这两位是01-12之间的数值
	    十三位和十四位是日期，是从01-31之间的数值
	    十五，十六，十七都是数字0-9
	    十八位可能是数字0-9，也可能是X
	    */
        var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
        // 判断格式是否正确
        var format = idcard_patter.test(idcode);
        var idcardJudge = null;
        if (last === last_no && format == true) {
          idcardJudge = "true";
        } else {
          idcardJudge = "false";
        }

        // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码

        //获取出生年月、性别、年龄
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        let iden = idcode;
        let sexnum = null;
        let sex = null;
        let birth = null;
        let age = 0;
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        sexnum = iden.substring(16, 17);
        if (sexnum % 2 === 0) {
          sex = "女";
        } else {
          sex = "男";
        }
        birth =
          iden.substring(6, 10) +
          "-" +
          iden.substring(10, 12) +
          "-" +
          iden.substring(12, 14);
        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        )
          age++;
        l["birth"] = birth;
        l["sex"] = sex;
        l["age"] = age;
        l["idcardJudge"] = idcardJudge;
      });
    },
    //判断手机号码格式
    judgePhone() {
      this.tableData.forEach(l => {
        const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
        if (regMobile.test(l.StrPhoneNum)) {
          this.phoneJudge = "true";
        } else {
          this.phoneJudge = "false";
        }
        l["judgePhone"] = this.phoneJudge;
        if (regMobile.test(l.StrContTel)) {
          this.contTelJudge = "true";
        } else {
          this.contTelJudge = "false";
        }
        l["contTelJudge"] = this.contTelJudge;
      });
    },
    //下拉立项部门
    getApartmentList(strsrvcent,strobjname){
      xz.getsrarchinstobjinstlist(strsrvcent,strobjname).then(res => {
        // console.log("getApartmentList", res);
        let dataList = []
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          dataList.push({StrObjInstName:apartmentData.StrObjInstName})
        }
        // console.log("getServeList", dataList);
        this.apartmentList = dataList;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-roster .search {
    height: 32px;
    padding: 5px 15px;
    margin-right: 10px;
    border-radius: 5px;
    background-color: #ebfaf5;
    border: 1px solid #62d2b4;
    color: #19BD92;
}
.historyFiled{
  margin-top: 20px;
}
.historyFiled .el-radio-group{
  display:inline-block!important;
  margin-right:10px;
  margin-top: 10px;
}
.result-box{
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58,.1);
}
.file-box{
  position: relative;
}
:focus {
  outline: 0;
}
.top-right {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.top-right .el-button--text{
  padding: 7px 10px;
  border: solid 1px #19BD92;
  font-size: 12px;
  color: #19BD92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img{
  vertical-align: sub;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display:inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: relative;
  top: 5px;
  left: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


<style >
.customerRosterTable .el-table td {
  padding: 8px 0;
}
.customerRosterTable .el-table th {
  padding: 12px 0;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}

.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.drop-downMenu .el-dropdown .el-dropdown-link {
  cursor: pointer;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.editInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.editInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .inputs {
  flex-wrap: wrap;
}
.dialog .el-drawer__body {
  overflow-y: scroll;
}
.fieldBox .el-checkbox__label {
  width: 120px!important;
  margin-bottom: 10px;
}
.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.el-drawer__body span:focus {
  outline: 0 !important;
}
.dialog .el-tabs--border-card > .el-tabs__content {
  max-height: 200px;
  overflow-y: scroll;
}
.dialog .el-card__body {
  max-height: 208px;
  overflow-y: scroll;
}
.tagArea .el-tag + .el-tag {
  margin-left: 10px;
}
.tagArea .el-checkbox_input.is-focus .el-checkbox_inner {
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked .el-checkbox__inner,
.tagArea .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19bd92;
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #19bd92;
}
.tagArea .el-checkbox__inner:hover {
  border-color: #19bd92;
}
.tagArea .el-tag--plain.el-tag--success {
  color: #19bd92;
}
.tagArea
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #19bd92;
}
.tagArea .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #19bd92;
}
.tableEditInput .el-input__inner {
  height: 25px;
  line-height: 25px;
  text-align: center;
  padding: 0;
  font-size: 13px;
}
.tableEditInput .el-input__icon {
  line-height: 25px;
}
.el-select-dropdown__item.selected {
  color: #19bd92 !important;
}
.historyFiled .el-radio-group{
  display: flex;
}
/* .historyFiled .el-radio--small.is-bordered{
  margin-bottom: 10px;
} */
</style>